/* GENERATED from pdp-matrix.src.js by build/gen_js.py - do not edit.
   The commented source is pdp-matrix.src.js. */
(function () {
'use strict';
var $  = function (sel, root) { return (root || document).querySelector(sel); };
var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
function money(cents) {
return '$' + (cents / 100).toFixed(2);
}
function init() {
var grid = $('[data-mx-grid]');
if (!grid) return;
var dataEl = $('[data-mx-variants]');
var variants = [];
try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
if (!variants.length) return;
var swatchWrap = $('[data-mx-swatches]');
var extraWrap = $('[data-mx-extras]');
var rows = $$('[data-mx-row]', grid);
var totalPcsEl = $('[data-mx-total-pcs]');
var totalPriceEl = $('[data-mx-total-price]');
var statusEl = $('[data-mx-status]');
var unavailableEl = $('[data-mx-unavailable]');
var mainImg = $('[data-gallery-main]');
var form = $('[data-mx-form]');
var labelIn = grid.getAttribute('data-mx-in');
var labelLow = grid.getAttribute('data-mx-low');
var labelOut = grid.getAttribute('data-mx-out');
var checkedSwatch = swatchWrap && $('[aria-checked="true"]', swatchWrap);
var color = checkedSwatch ? checkedSwatch.getAttribute('data-mx-color') : null;
var checkedExtra = extraWrap && $('[aria-checked="true"]', extraWrap);
var extra = checkedExtra ? checkedExtra.getAttribute('data-mx-extra') : null;
function variantFor(size, colorVal, extraVal) {
for (var i = 0; i < variants.length; i++) {
var v = variants[i];
if (v.size === size &&
(colorVal == null || v.color === colorVal) &&
(extraVal == null || v.extra === extraVal)) return v;
}
return null;
}
function paintRows() {
var anyMissing = false;
rows.forEach(function (row) {
var size = row.getAttribute('data-mx-size');
var v = variantFor(size, color, extra);
var priceEl = $('[data-mx-price]', row);
var stockEl = $('[data-mx-stock]', row);
var qtyInput = $('[data-mx-qty]', row);
var decBtn = $('[data-mx-dec]', row);
var incBtn = $('[data-mx-inc]', row);
if (!v) {
anyMissing = true;
row.setAttribute('data-mx-variant-id', '');
priceEl.textContent = '—';
stockEl.textContent = '';
stockEl.className = 'bmx__k';
qtyInput.value = '0';
qtyInput.disabled = true;
if (decBtn) decBtn.disabled = true;
if (incBtn) incBtn.disabled = true;
row.classList.remove('on');
return;
}
row.setAttribute('data-mx-variant-id', v.id);
priceEl.textContent = money(v.price);
var label = labelIn, cls = 'bmx__k--in';
if (v.stock === 'out') { label = labelOut; cls = 'bmx__k--out'; }
else if (v.stock === 'low') { label = labelLow; cls = 'bmx__k--low'; }
stockEl.textContent = label;
stockEl.className = 'bmx__k ' + cls;
var usable = v.available;
qtyInput.disabled = !usable;
if (decBtn) decBtn.disabled = !usable;
if (incBtn) incBtn.disabled = !usable;
if (!usable && qtyInput.value !== '0') { qtyInput.value = '0'; }
});
if (unavailableEl) { unavailableEl.hidden = !anyMissing; }
updateTotal();
}
function rowQty(row) {
var input = $('[data-mx-qty]', row);
var n = parseInt(input.value, 10);
return (isFinite(n) && n > 0) ? n : 0;
}
function updateTotal() {
var pcs = 0, total = 0;
rows.forEach(function (row) {
var q = rowQty(row);
var lineEl = $('[data-mx-line]', row);
if (q > 0) {
var v = variantFor(row.getAttribute('data-mx-size'), color, extra);
var line = v ? v.price * q : 0;
if (lineEl) lineEl.textContent = q > 0 ? money(line) : '';
pcs += q;
total += line;
row.classList.add('on');
} else {
if (lineEl) lineEl.textContent = '';
row.classList.remove('on');
}
});
if (totalPcsEl) { totalPcsEl.firstChild.nodeValue = String(pcs); }
if (totalPriceEl) { totalPriceEl.textContent = money(total); }
addState(false, pcs === 0);
}
function addState(busy, off) {
$$('[data-mx-add]').forEach(function (b) {
b.classList.toggle('is-busy', busy);
b.setAttribute('aria-busy', busy);
b.disabled = off;
});
}
function lineProperties() {
var props = {};
if (form) new FormData(form).forEach(function (value, key) {
if (key.indexOf('properties[') || typeof value !== 'string' || !value) return;
props[key.slice(11, -1)] = value;
});
return props;
}
if (swatchWrap) {
$$('[data-mx-color]', swatchWrap).forEach(function (btn) {
btn.addEventListener('click', function () {
if (btn.getAttribute('aria-checked') === 'true') return;
color = btn.getAttribute('data-mx-color');
$$('[data-mx-color]', swatchWrap).forEach(function (b) {
b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
});
paintRows();
if (mainImg) {
for (var i = 0; i < variants.length; i++) {
if (variants[i].color === color && variants[i].image) {
mainImg.src = variants[i].image;
break;
}
}
}
});
});
}
if (extraWrap) {
$$('[data-mx-extra]', extraWrap).forEach(function (btn) {
btn.addEventListener('click', function () {
if (btn.getAttribute('aria-checked') === 'true') return;
extra = btn.getAttribute('data-mx-extra');
$$('[data-mx-extra]', extraWrap).forEach(function (b) {
b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
});
paintRows();
});
});
}
grid.addEventListener('click', function (e) {
var dec = e.target.closest && e.target.closest('[data-mx-dec]');
var inc = e.target.closest && e.target.closest('[data-mx-inc]');
if (!dec && !inc) return;
var row = e.target.closest('[data-mx-row]');
var input = $('[data-mx-qty]', row);
if (input.disabled) return;
var n = rowQty(row) + (inc ? 1 : -1);
if (n < 0) n = 0;
input.value = String(n);
updateTotal();
});
grid.addEventListener('input', function (e) {
if (!e.target.matches || !e.target.matches('[data-mx-qty]')) return;
var n = parseInt(e.target.value, 10);
if (!isFinite(n) || n < 0) n = 0;
e.target.value = String(n);
updateTotal();
});
function addRun() {
var props = lineProperties();
var items = [];
rows.forEach(function (row) {
var q = rowQty(row);
var id = row.getAttribute('data-mx-variant-id');
if (q > 0 && id) { items.push({ id: +id, quantity: q, properties: props }); }
});
if (!items.length) return;
addState(true, true);
if (statusEl) { statusEl.hidden = true; }
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ items: items })
})
.then(function (r) {
if (!r.ok) { return r.json().then(function (d) { throw new Error(d.description || d.message || ''); }); }
return r.json();
})
.then(function () {
rows.forEach(function (row) { $('[data-mx-qty]', row).value = '0'; });
updateTotal();
if (statusEl) {
statusEl.textContent = grid.getAttribute('data-mx-added');
statusEl.hidden = false;
}
document.dispatchEvent(new CustomEvent('dtf:cart-add'));
})
.catch(function () {
if (statusEl) {
statusEl.textContent = grid.getAttribute('data-mx-error');
statusEl.hidden = false;
}
})
.then(updateTotal);
}
if (form) {
document.addEventListener('submit', function (e) {
if (e.target !== form) return;
e.preventDefault();
addRun();
});
}
paintRows();
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();
